import { v4 as uuidv4 } from "uuid";

import { faMessages, faPlus } from "@fortawesome/pro-solid-svg-icons";

import { AppRole } from "../../../@api";

import { FeatureCard } from "../../components/Pages";
import { lazyRouteWithGuards } from "../../components/Routes/Functions/LazyRouteFunction";
import { createLazyRoleCheckGuard } from "../../components/Routes/Guards/LazyRoleCheckGuard";
import { translationKeys } from "../../models/app-translation-keys";
import { RouteConstants } from "../../models/enums";
import { IStoreContext } from "../../stores/StoreContext";
import { IFeature } from "../iFeature";
import { ChatActionBar } from "./ChatActionBar/ChatActionBar";
import { ChatThreadHistory } from "./ChatSidebar/ChatThreadHistory";
import { NewThreadButton } from "./ChatSidebar/NewThreadButton/NewThreadButton";

const requiredRole = AppRole.ChatbotFeature;

const chatbotFeatureTooltipTranslationKeys = translationKeys.feature.chatbot.tooltip;

export const chatBotFeature: IFeature = {
  requiredRole,
  route: {
    path: RouteConstants.Chatbot,
    lazy: lazyRouteWithGuards({
      importer: () => import("./ChatBotPage"),
      componentName: "ChatBotPage",
      guards: [createLazyRoleCheckGuard(requiredRole)],
    }),
  },
  menuItem: {
    id: "chatbot",
    label: translationKeys.feature.chatbot.link,
    breadCrumbTitle: translationKeys.feature.chatbot.breadCrumbTitle,
    url: `/${[RouteConstants.Ai, RouteConstants.Chatbot].join("/")}`,
    path: RouteConstants.Chatbot,
    showFooter: true,
    hasSideBar: (storeContext: IStoreContext) => {
      return Promise.resolve(storeContext.settingsStore.persistAnyActions);
    },
    showSidebarTooltipKey: chatbotFeatureTooltipTranslationKeys.showChatHistory,
    hideSidebarTooltipKey: chatbotFeatureTooltipTranslationKeys.hideChatHistory,
    fontAwesomeIcon: faMessages,
    sidebarFeatureAreas: [
      {
        id: uuidv4(),
        titleKey: translationKeys.feature.chatbot.history.title,
        component: ChatThreadHistory,
      },
    ],
    sidebarAddNewButton: () => <NewThreadButton />,
    navbarItem: ChatActionBar,
  },
  card: (
    <FeatureCard
      featureKey="chatbot"
      requiresBudget={true}
      featureIcon={faMessages}
      buttonIcon={faPlus}
      route={RouteConstants.Ai}
      featureRoute={RouteConstants.Chatbot}
    />
  ),
};
